import PageDetail from "../abstract/PageDetail";

export default class PageReferences extends PageDetail {
	constructor() {
		super();
	}
	init($data) {

    window.conf = {
      UplElementTriggerId: null,
      UplElementDragId: null,
      UplMaxFileSize: "500", 
      UplMaxNumFile: 1, // <0 infinite
      UplDragEnabled: true,
      UplFilterTitle: "Images",
      UplFilterExtensions: "png,jpg,jpeg",
      UplFilterMimeTypes: "image/*",
      UplNaming: data.row.UidArcheologicalFind + "/conservation/{GUID}_{NNAMEBASE6}.{NEXT}",
      UplImageResample: "r=true,q=90,t=jpg,m=limit,s=1024x1024,d=72",
      UplRepositoryFolder: "/data/public/",
      UplThumbs: "p=.thumb.jpg,s=128x128,m=resize,q=80,d=72"
    }

		super.init($data, true);

	}

}

